import {ActionCreatorWithPayload} from '@reduxjs/toolkit';
import {useCallback} from 'react';
import {useAppDispatch, useAppSelector} from 'store/customer';
import {AppState} from 'store/customer/storeSetup';
import {
    removedVariationGSTSet,
    totalRemovedVariationCostSet,
} from 'components/customer/Confirmation/store/confirmationSlice';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';

export const useDeleteVariations = (
    selector: (store: AppState) => number[],
    deleteAction: ActionCreatorWithPayload<number>,
    restoreAction: ActionCreatorWithPayload<number>
) => {
    const {job} = useJobContext() as PartialJob;
    const ids = useAppSelector(selector);
    const dispatch = useAppDispatch();

    const deleteVariation = useCallback(
        (id: number, cost: number) => () => {
            dispatch(deleteAction(id));

            const gstOnVariation = cost * (Number(job.taxRate) / 100);

            dispatch(totalRemovedVariationCostSet(cost));
            dispatch(removedVariationGSTSet(gstOnVariation));
        },
        [deleteAction, dispatch, job.taxRate]
    );

    const restoreVariation = useCallback(
        (id: number, cost: number) => () => {
            dispatch(restoreAction(id));

            const gstOnVariation = cost * (Number(job.taxRate) / 100);

            dispatch(totalRemovedVariationCostSet(-cost));
            dispatch(removedVariationGSTSet(-gstOnVariation));
        },
        [restoreAction, dispatch, job.taxRate]
    );

    const isDeleted = useCallback((id: number) => ids.includes(id), [ids]);

    return {isDeleted, deleteVariation, restoreVariation};
};
